<template>
    <ShadowBoxContainer>

        <div class="ph4">
            <!-- image label -->
            <ListHeader
                :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
                imageLabel="General Information"
                heading="Give your listing a title."
            />

            <Textbox/>

            <Info title="What makes a good title?">
                <ul>
                    <li>Use descriptive keywords to clearly and accurately convery what you are listing.</li>
                    <li>Include the item's brand name.</li>
                    <li>State exacly what your item is, even if your title repeats the category name.</li>
                    <li>Omit punctuation marks and asterisks.</li>
                    <li>Use correct Spelling.</li>
                    <li>Don't use all capital letters</li>
                </ul>
            </Info>
        </div>

        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Cancel" forward="Next" @backClick="$router.push('/brand')" @forwardClick="$router.push('/add-photos')" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListHeader from '@/components/list/shared/ListHeader.vue';
import Info from '@/components/list/shared/Info.vue';
import Textbox from '@/components/controls/Textbox.vue';

export default {
    components: {
        NavigationButtons,
        ShadowBoxContainer,
        ListHeader,
        Info,
        Textbox
    }
};
</script>
